import ExcludeFromLookup from '../../../../../enums/ExcludeFromLookup';
import required from '../../../../form/field-validation/required';
import enabledSetting from '../enabledSetting';
import * as max from '../max-length-validators';

const isRequired = !!enabledSetting('company_name_is_required');
const hideCompanyName = !!enabledSetting('hide_company_name');

export default {
  name: 'companyName',
  label: 'checkout.delivery.address.field.label.company.name.text',
  hideCondition: hideCompanyName,
  maxLength: 35,
  validate: isRequired ? [required('company'), max.lengthCompany(35)] : max.lengthCompany(35),
  required: isRequired,
  excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
};
